// Kozponti API-alapcim — EGYETLEN forras az egesz frontend szamara.
//
// Miert letezik ez a fajl:
// A build-ido alatt eldolo REACT_APP_BACKEND_URL mar KETSZER localhost-ra allt
// egy elrontott build miatt (2026-05-14, majd 2026-07-09). Ilyenkor a bongeszo
// a felhasznalo SAJAT gepen futo http://localhost:8001-et probalja hivni, ahol
// nincs backend -> minden /api hivas (kod-belepes, urlapok) nemán elhal.
//
// Ez a helper a hibat OROKRE kizarja: eles domainen (barmely nem-localhost host)
// MINDIG relativ "/api"-t hasznalunk, ami ugyanarra a domainre megy az Nginx
// reverse-proxyn at. Igy a cim NEM build-idoben, hanem futasidoben, a bongeszoben
// dol el — egy rossz build sem tud tobbe localhost-ra kuldeni.
//
// Fejlesztes alatt (localhost / 127.0.0.1) a .env (REACT_APP_BACKEND_URL,
// alapertek: http://localhost:8001) adja a backend cimet, a szokott modon.
export const BACKEND_URL = (() => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host !== 'localhost' && host !== '127.0.0.1') {
      return ''; // eles: relativ /api -> ugyanaz a domain (Nginx proxy)
    }
  }
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
})();
